/**
 * Codename rename — PATCH /codenames/{family_key}.
 *
 * The family key is the root codename string the UI is displaying (an
 * enquiry's, a self-served report's, or a direct report request's). It
 * doubles as the optimistic-concurrency token: a stale key (someone else
 * renamed the family under a polling view) gets a 404 and the caller
 * should refetch silently. 409 means the requested name is already in use.
 */

export type CodenameRootEntityType = 'enquiry' | 'report' | 'report_request';

export interface CodenameRenameResult {
  oldCodename: string;
  newCodename: string;
  rootEntityType: CodenameRootEntityType;
  rootEntityId: string;
  inboxItemsUpdated: number;
  /** Backoffice projects now carrying the new name / that could not be
   * updated (recorded on that report; the rename itself is kept). */
  backofficeProjectsRenamed: number;
  backofficeProjectsFailed: number;
}

interface ApiCodenameRenameResponse {
  old_codename: string;
  new_codename: string;
  root_entity_type: CodenameRootEntityType;
  root_entity_id: string;
  inbox_items_updated: number;
  backoffice_projects_renamed?: number;
  backoffice_projects_failed?: number;
}

export function transformToCodenameRenameResult(
  api: ApiCodenameRenameResponse
): CodenameRenameResult {
  return {
    oldCodename: api.old_codename,
    newCodename: api.new_codename,
    rootEntityType: api.root_entity_type,
    rootEntityId: api.root_entity_id,
    inboxItemsUpdated: api.inbox_items_updated,
    backofficeProjectsRenamed: api.backoffice_projects_renamed ?? 0,
    backofficeProjectsFailed: api.backoffice_projects_failed ?? 0,
  };
}
